// extracted by mini-css-extract-plugin
module.exports = {"block":"_14481","list":"_18005","item":"_10045","actions":"_4445","icon":"_8637"};